import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

// TODO: Replace this component with the version from react-components v9.0.2 when
// consumer-web can handle the typescript upgrade (likely with node 18 upgrade)
export default function ClientOnly({ children }) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return <>{children}</>;
}

ClientOnly.propTypes = {
  children: PropTypes.node.isRequired,
};
